/**
 * Local Supabase port configuration
 *
 * AUTO-GENERATED by scripts/supabase-ports.ts — do not edit manually.
 * Re-generated on every `bun run setup` or `bun run db:start`.
 */

export const LOCAL_SUPABASE_PORTS = {
  api: 54470,
  db: 54471,
  shadowDb: 54472,
  studio: 54473,
  inbucket: 54474,
  pooler: 54475,
  analytics: 54476,
  analyticsVector: 54477,
  inbucketSmtp: 54478,
};

export const LOCAL_SUPABASE_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.api}`;
export const LOCAL_SUPABASE_STUDIO_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.studio}/project/default/editor`;
export const LOCAL_INBUCKET_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.inbucket}`;
export const LOCAL_INBUCKET_SMTP_PORT = LOCAL_SUPABASE_PORTS.inbucketSmtp;
